import { gql } from '@apollo/client'
import { client } from '../client';


const REGISTER_TRANSPORTATION_MUTATION = gql`
  mutation Mutation($languageId: Int!, $driverName: String, $driverIdNo: String, $driverIdType: String, $phoneNumber: String, $transportationTypeId: Int, $productId: Int, $registrationNumber: String, $announcementId: Int) {
    registerTransportation(languageId: $languageId, driverName: $driverName, driverIdNo: $driverIdNo, driverIdType: $driverIdType, phoneNumber: $phoneNumber, transportationTypeId: $transportationTypeId, productId: $productId, registrationNumber: $registrationNumber, announcementId: $announcementId) {
      transportationId
    }
  }
`

interface RegisterTransportationData {
  registerTransportation: {
    transportationId: number
  }
}

interface RegisterTransportationVars {
  languageId: number,
  driverName: string,
  driverIdNo?: string | null,
  driverIdType?: string | null,
  phoneNumber: string,
  transportationTypeId?: number | null,
  productId?: number | null,
  registrationNumber: string,
  announcementId?: number | null,
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const registerTransportation = (args: RegisterTransportationVars) => {
  return client.mutate<RegisterTransportationData, RegisterTransportationVars>({
    mutation: REGISTER_TRANSPORTATION_MUTATION,
    variables: args,
  })
}
